import { Link } from "react-router-dom";
import { SUBURBS_SEO, REGIONS } from "../lib/suburbs";
import { MapPin, ArrowUpRight } from "@phosphor-icons/react";

const FEATURED_SLUGS = [
  "brighton", "hampton", "sandringham", "mentone", "mordialloc",
  "frankston-south", "mornington", "mount-eliza", "sorrento",
  "glen-waverley", "berwick", "caulfield",
];

export default function ServiceAreas() {
  const featured = FEATURED_SLUGS
    .map((slug) => SUBURBS_SEO.find((s) => s.slug === slug))
    .filter(Boolean);

  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="relative py-20 md:py-32 px-5 md:px-10 lg:px-16 bg-[#EAEAE5] border-y-2 border-[#111]"
    >
      <div className="grid grid-cols-12 gap-6 mb-10">
        <div className="col-span-12 md:col-span-5">
          <p className="section-num mb-3">06 — Service map</p>
          <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter leading-[0.9]">
            South-east<br />to the<br />
            <span className="text-[#D85C3A]">peninsula.</span>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-7 md:pt-16">
          <p className="text-lg leading-relaxed">
            Crews on the road every weekday, from the inner south-east through bayside and right
            down the Mornington Peninsula. {SUBURBS_SEO.length} suburbs covered — pick yours below
            for a tailored local quote.
          </p>
        </div>
      </div>

      {/* Google Maps free embed */}
      <div className="border-2 border-[#111] mb-10 overflow-hidden shadow-brut bg-[#F2F2EF]">
        <iframe
          data-testid="service-map"
          title="The Melbourne Painters service area"
          src="https://www.google.com/maps?q=Mornington%20Peninsula%2C%20Victoria%2C%20Australia&output=embed&z=9"
          width="100%"
          height="380"
          style={{ border: 0, display: "block" }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>

      {/* Featured + see-all link */}
      <div className="flex items-end justify-between mb-4 flex-wrap gap-3">
        <p className="text-xs uppercase tracking-widest font-bold">Featured suburbs</p>
        <Link
          to="/painters"
          data-testid="see-all-suburbs"
          className="text-xs uppercase tracking-widest font-bold flex items-center gap-1 hover:text-[#D85C3A]"
        >
          See all {SUBURBS_SEO.length} suburbs <ArrowUpRight size={16} weight="bold" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {featured.map((s) => (
          <Link
            to={`/painters/${s.slug}`}
            key={s.slug}
            data-testid={`area-${s.slug}`}
            className="border-2 border-[#111] p-4 bg-[#F2F2EF] hover:bg-[#D85C3A] hover:text-white transition-colors group"
          >
            <div className="flex items-start justify-between">
              <span className="font-display text-base md:text-lg uppercase tracking-tight">{s.name}</span>
              <MapPin size={16} weight="duotone" className="opacity-50 group-hover:opacity-100" />
            </div>
            <div className="text-[10px] uppercase tracking-widest opacity-60 mt-1">{s.region}</div>
          </Link>
        ))}
      </div>

      <div className="mt-8 text-sm text-[#666]">
        Covering: {REGIONS.join(" · ")} — and surrounding metro suburbs. <Link to="/painters" className="underline font-bold hover:text-[#D85C3A]">View all suburbs →</Link>
      </div>
    </section>
  );
}
